import React from 'react';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import {
  commonPCConsoleDefaultFilterValue,
  handleDetailPhysicalFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import PCUPhysicalDigital from '../index';
import {
  TopchartPageId,
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import {
  getDeviceValuesByPageId,
  getDeviceConfig,
  getDeviceOptionByType,
  getPlatformDeviceCascaderOptions,
} from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import { useIntl } from 'umi';
import {
  getDetailPageCfg,
  DETAIL_PAGEID,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_config';
import {
  statsTrend,
  statsCountriesTrend,
  statsCountriesTable,
} from '@/pages/intelligence/services/topcharts';

export default function DigitalRevenue(props: any) {
  const {
    entityType,
    gameId,
    pageId,
    tabType,
    gsdDevicesFlatten,
    gsdSegments,
    downloadModalSize,
  } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  const physicalDeviceOptions = getDeviceOptionByType(
    TopchartPageId.PhysicalRevenue,
    entityType,
  );

  const defaultFilterValue = {
    ...commonPCConsoleDefaultFilterValue,
    [filterKeyMap.PHYSICAL_DEVICE]: {
      value: getDeviceValuesByPageId(
        TopchartPageId.PhysicalRevenue,
        entityType,
      ),
    },
  };

  const hasDevice =
    entityType === 'console' || entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE;

  const filterKeyList = [filterKeyMap.RANGE_TIME];
  if (hasDevice) {
    filterKeyList.push(filterKeyMap.PHYSICAL_DEVICE);
  }

  const filterCfg = {
    filterKeyList,
    regionFilterParams: {},
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
    },
    specialParams: {
      regionOptions: [], // 国家筛选器options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: true,
      rangeTimeType: FilterTimeType.rangeMonth,
      // disableIegg: false,
      // disableAnnie: true,
      isShowAlloftime: false,
      showShortcut: true,
      physicalDeviceOptions,
      [filterKeyMap.PHYSICAL_DEVICE]: {
        useCascaderStyle: true,
        cascaderHierarchicalOptions: getPlatformDeviceCascaderOptions(
          physicalDeviceOptions,
        ),
      },
      entityType,
    },
    showConfirmButton: false,
    haveFilterSaveBtn: false,
    handleFilterToApiParams: handleDetailPhysicalFilterParamsToApi,
  };

  const deviceDefVales = getDeviceConfig(pageId, entityType)?.value;
  const pageCfg = getDetailPageCfg(pageId, tabType, entityType);
  const defaultByDeviceVal = pageCfg?.defaultByDeviceVal || undefined;
  const params = {
    source: 'npd',
    tab_name: 'physical_revenue',
    regions: ['us'],
    segment: '',
    sort_field: 'revenue',
    unified_id: gameId,
    entity_type: entityType,
    region_type: 'market',
    start_date: '',
    end_date: '',
    date_type: 'monthly',
    sort_type: 'desc',
    device: hasDevice ? deviceDefVales : undefined,
    b_group_by_device: defaultByDeviceVal,
    metric: ['physicalRevenue'],
  };

  return (
    <PCUPhysicalDigital
      {...props}
      // entityType={'console'}
      // pageId={pageId}
      // pageLogInfo={dbiPageLogMes.topChartsConsoleGamesDigitalRevenue}
      // tableCloumsList={digitalRevenueList}
      // hasRegionFilter={true}
      // cardMetricName={formatMessage({ id: 'dbi_digital_revenue' })}
      downloadModalSize={downloadModalSize}
      filterCfg={filterCfg}
      filterLoading={false}
      // rangeTimeComponentDefault={latestTimeTypeHasData}
      filterIcon={
        <span className="dbi-statsfilter-warp-left-text">
          {formatMessage({ id: 'dbi_us_only' })}
        </span>
      }
      pageCfg={pageCfg}
      pageParameters={params}
      releaseInFortyDay={false} // 这里因为是只有月粒度，所以这里配置为false不让它为日粒度
      metricKey={DETAIL_PAGEID.physicalRevenue}
      gsdDevicesFlatten={gsdDevicesFlatten}
      gsdSegments={gsdSegments}
      getTrendsFun={statsTrend}
      getMarketTrendsFun={statsCountriesTrend}
      getMarketTableFun={statsCountriesTable}
    />
  );
}
